<template>
  <div>
    <router-view />
    <feedback />
    <alert />
    <modal />
    <prompt />
    <notification></notification>
  </div>
</template>

<script>
import Alert from '@/components/shared/Alert.vue';
import Modal from '@/components/shared/Modal.vue';
import Prompt from '@/components/shared/Prompt.vue';
import Feedback from '@/components/sections/feedback/FeedbackForm.vue';
import { isLoggedIn$ } from '@/services';
import { ref, onMounted } from 'vue';
import { isInIframe, listenToParentMessages, exposeElementsToParent, notifyUrlChanges } from '@/utils/iframeUtils';
import mitt from 'mitt';

export default {
  name: 'App',
  components: {
    Alert,
    Modal,
    Prompt,
    Feedback
  },
  setup() {
    // Define reactive variable for isLoggedIn
    const isLoggedIn = ref(false);

    // Fetch initial value of isLoggedIn
    const fetchInitialValue = () => {
      isLoggedIn$.subscribe((value) => {
        isLoggedIn.value = value;
      });
    };

    // Call fetchInitialValue when component is mounted
    onMounted(fetchInitialValue);

    return {
      isLoggedIn
    };
  },
  mounted() {
    // Allow iframe embedding by removing X-Frame-Options header
    if (document.head.querySelector('meta[http-equiv="X-Frame-Options"]')) {
      document.head.querySelector('meta[http-equiv="X-Frame-Options"]').remove();
    }

    // Add Content-Security-Policy meta tag to allow iframe embedding
    const cspMeta = document.createElement('meta');
    cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
    cspMeta.setAttribute('content', "frame-ancestors 'self' *");
    document.head.appendChild(cspMeta);

    // Setup iframe communication if we're in an iframe
    if (isInIframe()) {
      // Start URL change notifications
      notifyUrlChanges();

      // Listen for messages from parent
      const cleanup = listenToParentMessages((message) => {
        if (message.type === 'getElements') {
          // Expose specific elements to parent
          exposeElementsToParent(message.selector, message.eventType);
        }
      });

      // Cleanup on component unmount using mitt
      const emitter = mitt();
      emitter.on('beforeDestroy', cleanup);
    }

    let host = window.location.host;
    document.title = 'Mediq Voorschrijfportaal';

    // Google Tag Manager
    let gtmScript = document.createElement('script');
    gtmScript.innerHTML =
      "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-5JZVM3L');";
    document.head.appendChild(gtmScript);
    let gtmNoScript = document.createElement('noscript');
    gtmNoScript.innerHTML =
      "<iframe src='https://www.googletagmanager.com/ns.html?id=GTM-5JZVM3L' height='0' width='0' style='display:none;visibility:hidden'></iframe>";
    document.body.appendChild(gtmNoScript);
    // End Google Tag Manager

    window.addEventListener('message', (event) => {
      // Verify the origin of the message for security
      if (!event.origin.match(/^https?:\/\/(.*\.mediq\.nl|medbis\.localhost)/)) return;

      // Handle messages from parent
      if (event.data.type === 'navigation') {
        this.$router.push(event.data.path);
      }
    });
  }
};
</script>
